// Auto-generated by Storyline Creator (Vite)

export default {
  "id": "the_doubt",
  "title": "The Doubt",
  "coverImage": "",
  "requirements": [
    {
      "type": "flag",
      "key": "accept_trinket2",
      "eq": true
    }
  ],
  "startScene": "start",
  "scenes": {
    "start": {
      "steps": [
        {
          "type": "page",
          "image": "/images/the_doubt_1.png",
          "text": "Click to continue."
        },
        {
          "type": "choice",
          "image": "/images/the_doubt_2.png",
          "prompt": "Drag to choose.",
          "left": {
            "label": "Return home.",
            "if": [
              {
                "type": "flag",
                "key": "accept_trinket2",
                "eq": true
              }
            ],
            "effects": [
              {
                "type": "sanity",
                "delta": 10
              },
              {
                "type": "flag",
                "key": "return_home",
                "value": true
              }
            ],
            "nextScene": "scene_1",
            "nextStorylet": "a_friendly_weapon"
          },
          "right": {
            "label": "Endure.",
            "if": [],
            "effects": [
              {
                "type": "flag",
                "key": "return_home",
                "value": false
              }
            ],
            "nextScene": "end",
            "nextStorylet": "the_last_tomb"
          }
        }
      ]
    },
    "scene_1": {
      "steps": [
        {
          "type": "page",
          "image": "/images/the_doubt_3.png",
          "text": "Click to end."
        }
      ]
    },
    "end": {
      "steps": [
        {
          "type": "page",
          "image": "/images/the_doubt_4.png",
          "text": "Click to continue."
        },
        {
          "type": "ending",
          "image": "/images/the_doubt_5.png",
          "text": "Click to end.",
          "effects": []
        }
      ]
    }
  }
};
